<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Résultat des dispatchings par PDF
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col>
              <v-btn @click="savePDF" block class="custom-btn white--text" color="#00BCD4" height="45px"
                     large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Télécharger PDF</span>
              </v-btn>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <template>
            <modal :adaptive=true
                   :clickToClose=true
                   :draggable=false
                   :resizable=false
                   height="auto"
                   name="modal-fade"
                   width="80%">
              <template>
                <vue-pdf-app
                    :file-name="fileNameSrc"
                    :pdf="pdfsrc"
                    :title="true"
                    style="height: 100vh;">
                </vue-pdf-app>
              </template>
            </modal>
          </template>
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import {depthDate} from "../../../helper/profondeur";
import imageToBase64 from "image-to-base64/browser";
import jsPDF from "jspdf";
import MotionPicture from "../../../assets/Fonts/MotionPicture-normal";
import VuePdfApp from "vue-pdf-app";
import "vue-pdf-app/dist/icons/main.css";

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "account_details",
  components: {HotTable, VuePdfApp},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      fileNameSrc: null,
      pdfsrc: null,
      bShowPDF: true,
      indEnr: 0,
      namePDFile: "Détails des dispatchings TSA",
      imgFooter: require('../../../assets/Logo_TSA_fine.png'),
      heading: "Dispatching ",
      tabDispatchAllMessages: [],
      idFctIssuer: "",
      observations: "",
      nameCtgContraintesAgt: [],
      nameCategAgent: [],
      nameContrainteAgent: [],
      disableMainBtn: false,
      commande: "",
      searchName: "",
      shifts: [],
      shiftsFull: [],
      namePostsZones: [],
      namePosts: [],
      nameZones: [],
      dialogTmp: false,
      fileBtn: true,
      drag_over: false,   // dragging over the target OR any child element
      over_others: false, // dragging over a child element
      files: [],
      lastHighlitedRow: null,
      menu: null,
      menu1: null,
      menuS: null,
      type: null,
      elapse: null,
      loading: false,
      menustartWorkingDate: false,
      toObject: [],
      selectDates: depthDate,
      depthVal: {
        name: sessionStorage.getItem("depthValChoosedt"),
        value: sessionStorage.getItem("depthValChoosedd")
      },
      editedItem: {
        id: "",
        postName: "",
        zoneName: "",
        zoneName1: "",
        shiftName: "",
        shiftNameS: "",
        dispatchingDate: (moment().format("YYYY-MM-DD")).toString(),
        brigade: "",
        userId: "",
        postName1: "",
        shiftName1: "",
        dispatchingDate1: (moment().format("YYYY-MM-DD")).toString(),
        dispatchingDateS: (moment().format("YYYY-MM-DD")).toString(),
        userId1: "",
        accountFirstname: "",
        accountLastname: "",
        imgRadio: false,
        bbgSouteCab: false,
        filtrePersObj: false,
        filtreFretPoste: false,
        fouilleCtrlVeh: false,
        formed: false,
        sensitized: false,
        sexe: "",
      },
      show1: false,
      e6: 1,
      tab: null,
      dialog: false,
      alert: false,
      fullPage: false,
      text: "",
      color: "",
      file: "",
      editedIndex: -1,
      errors: [],
      excelData: [],
      arrayAbs: [],
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        selectionMode: "single",
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        minSpareRows: false,
        contextMenu: ["remove_row"],
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        afterChange: this.afterChangeMe,
        beforeRemoveRow: this.beforeRemoveRowMe,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        manualColumnResize: true,
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0],
          indicators: false
        },
        colHeaders: [
          "Id", "Date dispatching", "Nom shift", "Brigade", "Nom zone", "Nom poste", "Catégorie", "Matricule", "Nom", "Prénom(s)", "Statut", "Date création"
        ],
        columns: [
          {title: "Id", width: "80px", readOnly: true},
          {
            title: "Date dispatching",
            width: "180px",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
          {title: "Nom shift", width: "200px", readOnly: true},
          {title: "Brigade", width: "200px", readOnly: true},
          {title: "Nom zone", width: "160px", readOnly: true},
          {title: "Nom poste", width: "350px", readOnly: true},
          {title: "Catégorie", width: "180px", readOnly: true},
          {title: "Matricule", width: "150px", readOnly: true},
          {title: "Nom", width: "160px", readOnly: true},
          {title: "Prénom(s)", width: "200px", readOnly: true},
          {title: "Statut", width: "200px", readOnly: true},
          {
            title: "Date création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          }
        ],
      }
    }
  },
  created() {
    this.getData()
  },

  methods: {
    show() {
      this.$modal.show('modal-fade');
    },
    hide() {
      this.$modal.hide('modal-fade');
    },
    depthDate() {
      if (this.depthVal) {
        sessionStorage.setItem("depthValChoosedd", this.depthVal.value)
        sessionStorage.setItem("depthValChoosedt", this.depthVal.name)
      }
      this.getData()
    },
    cleared() {
      this.searchName = "";
      this.getData()
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 1, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }

      this.$refs.hotTable.hotInstance.loadData(array);
    },
    init() {
      this.tab = "tab-1";
      this.file = "";
      this.files = [];
      this.fileBtn = true;
      this.drag_over = false;
    },
    dragEnter(e) {
      if (e.target === this.$refs.others)
        this.over_others = true
      else
        this.drag_over = true
    },
    dragOver(e) {
      if (e.target === this.$refs.others) this.over_others = true
      else this.drag_over = true
    },
    dragLeave(e) {
      if (e.target === this.$refs.others) this.over_others = false
      else if (!this.over_others) this.drag_over = false
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    getData() {
      this.bShowPDF = true;
      this.loading = true
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/lastdispatchingresultsbyuser` + "/" + sessionStorage.getItem("userId")
          )
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                this.convertDate(item["dispatchingDate"]),
                this.isEmpty(item["shiftName"]) ? "" : item["shiftName"].toUpperCase(),
                this.isEmpty(item["brigade"]) ? "" : item["brigade"].toUpperCase(),
                (item["zoneName"].toUpperCase() === "TOUTES ZONES") ? "ZONE X" : item["zoneName"].toUpperCase(),
                this.isEmpty(item["postName"]) ? "" : item["postName"].toUpperCase(),
                this.isEmpty(item["category"]) ? "" : ((item["aao"] === true) ? (item["category"].toUpperCase() + " - AAO") : item["category"].toUpperCase()),
                item["userId"],
                this.isEmpty(item["accountLastname"]) ? "" : item["accountLastname"].toUpperCase(),
                this.isEmpty(item["accountFirstname"]) ? "" : item["accountFirstname"].toLowerCase().capitalize(true),
                this.isEmpty(item["status"]) ? "" : item["status"],
                this.datefull(item["creationDate"])
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]

            this.getNotifsByDateDepth(0)
          })
          .catch(() => {
            this.loading = false
          });
    },
    getMessagesByDateShift(idFctIssuer) {
      let result = []
      let stTmp = []
      this.tabDispatchAllMessages.forEach(item => {
        stTmp = item.message.split('\n')

        if (item.idFctIssuer === idFctIssuer) {
          if (stTmp.length >= 2) {
            result.push(stTmp[1] + ((stTmp.length === 3) ? (" : " + stTmp[2]) : ""));
          }
        }
      })

      return result
    },
    getNotifsByDateDepth(valeur) {
      let dateChoosed = moment().subtract(valeur, "days").format("DD-MM-YYYY")
      this.tabDispatchAllMessages = []

      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/notification/getnotifsbydatebydepth/` + dateChoosed + "/Admin"
          )
          .then(res => {
            if (res.data.status === 200) {
              for (let i = 0; i < res.data.datas.length; i++) {
                this.tabDispatchAllMessages.push(res.data.datas[i]);
              }

              this.generatePDF(false);
            }
          })
          .catch(() => {
          });
    },
    getNbrAgentsByBRG(tab, date, shift, brg) {
      let nbr = 0
      for (var i = 0; i < tab.length; i++) {
        if ((tab[i][1] === date) && (tab[i][2] === shift) && (tab[i][3] === brg)) {
          ++nbr;
        }
      }

      return nbr;
    },
    getNbrAgentsByZone(tab, date, shift, brg, zone) {
      let nbr = 0
      for (var i = 0; i < tab.length; i++) {
        if ((tab[i][1] === date) && (tab[i][2] === shift) && (tab[i][3] === brg) && (tab[i][4] === zone)) {
          ++nbr;
        }
      }

      return nbr;
    },
    getNbrAgentsByDispatchDateShift(tab, date, shift) {
      let nbr = 0
      for (var i = 0; i < tab.length; i++) {
        if ((tab[i][1] === date) && (tab[i][2] === shift)) {
          ++nbr;
        }
      }

      return nbr;
    },
    generatePDF(bSave) {
      let imgBase64 = ""

      imageToBase64(require('../../../assets/Logo_TSA_fine.png')) // Image URL
          .then(
              (response) => {
                imgBase64 = response

                if (this.toObject.length <= 1) {
                  this.text = "Dispatching non disponible.";
                  this.showAlert('warning')
                  this.bShowPDF = false;
                  return;
                }

                let doc = new jsPDF({
                  orientation: "portrait",
                  unit: "in",
                  format: "letter"
                });

                let brgNameCurrent = ""
                let zoneNameCurrent = ""
                let nameDispatchShift = ""
                let currentShift = ""
                let currentDate = ""
                let nextShift = ""
                let nextDate = ""

                let refCurrent = ""
                let refOld = ""
                let indi = 0
                let indj = 0

                let nbrAgentsByBRG = 0
                let nbrAgentsByZone = 0
                let nbrAgentsByDispatchDateShift = 0

                let toObjectTmp = []
                Array.prototype.push.apply(toObjectTmp, this.toObject);
                toObjectTmp.shift()

                for (indi = 0; indi < toObjectTmp.length; indi++) {
                  let finalTab = []

                  currentDate = toObjectTmp[indi][1]
                  currentShift = toObjectTmp[indi][2]

                  nameDispatchShift = currentDate + " / " + currentShift
                  brgNameCurrent = toObjectTmp[indi][3]
                  zoneNameCurrent = toObjectTmp[indi][4]

                  for (indj = indi; indj < toObjectTmp.length; indj++) {
                    refOld = refCurrent;
                    refCurrent = toObjectTmp[indj][3] + " " + toObjectTmp[indj][4]

                    if (refOld === "") { // Le 1er
                      finalTab.push(toObjectTmp[indj]);
                    } else {
                      if (refOld !== refCurrent) {
                        break;
                      }
                      finalTab.push(toObjectTmp[indj]);
                    }
                  }

                  indi = indj - 1;

                  nbrAgentsByBRG = this.getNbrAgentsByBRG(toObjectTmp, currentDate, currentShift, brgNameCurrent)
                  nbrAgentsByDispatchDateShift = this.getNbrAgentsByDispatchDateShift(toObjectTmp, currentDate, currentShift)

                  doc.autoTable({
                    head: this.headRowsBRG(brgNameCurrent.toUpperCase(), nbrAgentsByBRG),
                    headStyles: {
                      fillColor: [241, 196, 15],
                      fontSize: 15,
                      valign: 'middle'
                    },
                    footStyles: {
                      fillColor: [241, 196, 15],
                      fontSize: 12,
                      halign: 'right',
                      valign: 'middle'
                    },
                    lineWidth: 1,
                    tableLineColor: [241, 196, 15], //choose RGB
                    tableLineWidth: 0.02, //table border width
                    margin: {left: 0.75, top: 1.90, right: 0.75},
                    pageBreak: 'always', //'avoid'|'always'

                    didParseCell: function (data) {
                      if ((data.row.section === 'head') && (data.cell.text[0] === "(" + nbrAgentsByBRG + ")")) {
                        data.cell.styles.halign = 'right'
                        data.cell.styles.minCellWidth = 0.9
                      }

                      if ((data.row.section === 'head') && (data.cell.text[0] === brgNameCurrent.toUpperCase())) {
                        data.cell.styles.halign = 'right'
                      }
                    },

                    didDrawPage: function (data) {
                      // Header
                      //https://rawgit.com/MrRio/jsPDF/master/fontconverter/fontconverter.html pour convertir le font ttf en js.
                      doc
                          .addImage(response, 'PNG', 0.75, 0.75, 1.1, 1)
                          .addFileToVFS('MotionPicture-normal.ttf', MotionPicture)
                          .setFont("MotionPicture", 'normal')
                          .setFontSize(50)
                          .setTextColor(25, 52, 101)
                          .text("Dispatching", 3.20, 1.20);

                      doc
                          .setFont("times", "bolditalic")
                          .setFontSize(15)
                          .setTextColor(19, 39, 76)
                          .text(
                              nameDispatchShift + " (" + nbrAgentsByDispatchDateShift + ")",
                              7.75,
                              1.70,
                              {align: "right"}
                          )

                      // create a line under heading
                      doc.setDrawColor(19, 39, 76);
                      doc.setLineWidth(0.03).line(0.75, 1.80, 7.75, 1.80);
                      // Using autoTable plugin
                    },
                  });

                  nbrAgentsByZone = this.getNbrAgentsByZone(toObjectTmp, currentDate, currentShift, brgNameCurrent, zoneNameCurrent)
                  doc.autoTable({
                    startY: doc.lastAutoTable.finalY + 0.05,
                    head: this.headRowsZone(zoneNameCurrent.toUpperCase(), nbrAgentsByZone),
                    headStyles: {
                      fillColor: [74, 96, 117],
                      fontSize: 12,
                      halign: 'center',
                      valign: 'middle'
                    },
                    lineWidth: 1,
                    tableLineColor: [74, 96, 117], //choose RGB
                    tableLineWidth: 0.02, //table border width
                    margin: {left: 0.85, right: 0.85},

                    didParseCell: function (data) {
                      if ((data.row.section === 'head') && (data.cell.text[0] === "(" + nbrAgentsByZone + ")")) {
                        data.cell.styles.halign = 'right'
                        data.cell.styles.minCellWidth = 0.6
                      }

                      if ((data.row.section === 'head') && (data.cell.text[0] === zoneNameCurrent.toUpperCase())) {
                        data.cell.styles.halign = 'right'
                      }
                    },
                  });

                  let tabTPostMat = []
                  let posteNameCurrent = ""
                  let posteNameNext = ""
                  let incrSaut
                  let b1stSaut = 1;
                  let bFin = false;

                  for (var indk = 0; indk < finalTab.length; indk++) {
                    posteNameCurrent = finalTab[indk][5]

                    if (indk === (finalTab.length - 1)) {
                      bFin = true
                      posteNameNext = finalTab[indk][5]
                    } else {
                      posteNameNext = finalTab[indk + 1][5]
                    }

                    if ((posteNameCurrent === posteNameNext) && (bFin === false)) {
                      tabTPostMat.push([finalTab[indk][1], finalTab[indk][2], finalTab[indk][3], finalTab[indk][4], finalTab[indk][5], finalTab[indk][6], finalTab[indk][7], finalTab[indk][8], finalTab[indk][9]]);
                    } else {
                      tabTPostMat.push([finalTab[indk][1], finalTab[indk][2], finalTab[indk][3], finalTab[indk][4], finalTab[indk][5], finalTab[indk][6], finalTab[indk][7], finalTab[indk][8], finalTab[indk][9]]);

                      if ((posteNameCurrent !== posteNameNext) || (bFin === true)) {
                        if (b1stSaut === 1) {
                          incrSaut = 0
                          b1stSaut = 0
                        } else {
                          incrSaut = 0.2
                        }

                        doc.autoTable({
                          startY: doc.lastAutoTable.finalY + 0.03 + incrSaut,
                          head: this.headRowsPoste(posteNameCurrent, zoneNameCurrent),
                          headStyles: {
                            fillColor: [155, 89, 182],
                            fontSize: 10
                          },
                          margin: {left: 0.85, right: 0.85},

                          didParseCell: function (data) {
                            if ((data.row.section === 'head') && (data.cell.text[0] === zoneNameCurrent)) {
                              data.cell.styles.halign = 'right'
                            }
                          },
                        });

                        doc.autoTable({
                          startY: doc.lastAutoTable.finalY + 0.03,
                          head: this.bodyHead(),
                          body: this.bodyRows(tabTPostMat),
                          headStyles: {
                            fontSize: 10,
                          },
                          bodyStyles: {
                            fontSize: 10
                          },
                          margin: {left: 0.85, right: 0.85},
                          columnStyles: {
                            0: {cellWidth: 1},
                            1: {cellWidth: 2.9},
                            2: {cellWidth: 2}
                          },
                        });

                        tabTPostMat = []
                      }
                    }
                  }

                  if (indi !== (toObjectTmp.length - 1)) {
                    nextDate = toObjectTmp[indi + 1][1]
                    nextShift = toObjectTmp[indi + 1][2]
                  } else {
                    nextDate = ""
                    nextShift = ""
                  }

                  if (((nextDate === "") || (nextShift === "")) || ((currentDate !== nextDate) || (currentShift !== nextShift))) {
                    let result = this.getMessagesByDateShift(currentDate + " " + currentShift)

                    let elt = "Messages pour le dispatching du " + currentDate + " " + currentShift + ""
                    doc
                        .setFont("helvetica", "bold")
                        .setFontSize(16)
                        .text(elt, 1.09, doc.lastAutoTable.finalY + 1);

                    doc.autoTable({
                      startY: doc.lastAutoTable.finalY + 1.3,
                      head: this.headRowsMessages(),
                      body: this.bodyMessages(result),
                      headStyles: {
                        fontSize: 12,
                        fillColor: [185, 151, 91]
                      },
                      bodyStyles: {
                        fontSize: 10,
                        fillColor: [239, 219, 178]
                      },
                      margin: {left: 0.85, right: 0.85},
                    })

                    // PAGE NUMBERING
                    // Add Page number at bottom-right
                    // Get the number of pages
                    const pageCount = doc.internal.getNumberOfPages();

                    // For each page, print the page number and the total pages
                    for (var i = 1; i <= pageCount; i++) {
                      // Go to page i
                      doc.setPage(i);
                      //Print Page 1 of 4 for example  // Creating footer and saving file
                      this.footPage(doc)
                      doc
                          .setTextColor(25, 52, 101)
                          .text("Page " + String(i - 1) + " sur " + String(pageCount - 1), 7.7, doc.internal.pageSize.height - 0.5, {align: "right"});
                    }

                    doc.deletePage(1)

                    if (bSave === true) {
                      doc.save(`${this.heading} du ${currentDate}.${currentShift}.pdf`);
                    } else {
                      this.pdfsrc = doc.output("arraybuffer");
                      this.fileNameSrc = this.heading + " du " + currentDate + "." + currentShift + ".pdf"
                      this.show()
                    }

                    doc = new jsPDF({
                      orientation: "portrait",
                      unit: "in",
                      format: "letter"
                    });
                  }
                }
              }
          )
          .catch(
              (error) => {
                console.log(error); // Logs an error if there was one
              }
          )
    },
    bodyMessages(result) {
      var body = []
      for (var j = 0; j < result.length; j++) {
        body.push({
          name: result[j],
        })
      }
      return body
    },
    headRowsMessages() {
      return [
        {name: "Messages"},
      ]
    },
    headRowsBRG(brgName, size) {
      return [
        {name: brgName, size: "(" + size + ")"},
      ]
    },
    headRowsZone(zoneName, size) {
      return [
        {name: zoneName, size: "(" + size + ")"},
      ]
    },
    headRowsPoste(poste, zone) {
      return [
        {name: 'POSTE :            ' + poste, zone: zone},
      ]
    },
    bodyHead() {
      return [
        {matricule: 'Matricule', name: 'Nom agent', categorie: 'Catégorie', date: 'Date'},
      ]
    },
    bodyRows(tabObject) {
      var body = []

      for (var j = 0; j < tabObject.length; j++) {
        body.push({
          matricule: tabObject[j][6],
          name: tabObject[j][7].toUpperCase() + " " + tabObject[j][8],
          categorie: tabObject[j][5],
          date: tabObject[j][0],
        })
      }
      return body
    },
    footPage(doc) {
      // Creating footer and saving file
      doc
          .setFont("times", "italic")
          .setFontSize(11)
          .setTextColor(25, 52, 101)
          .text(
              "Powered with love by CartaLink - (TSA / Aéroport AIBD) - Document confidentiel.",
              0.75,
              doc.internal.pageSize.height - 0.5
          )
    },
    savePDF() {
      this.generatePDF(true)
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData()
    },
    datefull(val) {
      if (!val) {
        return
      }
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY HH:mm:ss");
    },
    convertDate(val) {
      const date = new Date(val);
      return moment(date).format("DD-MM-YYYY");
    },
    close() {
      this.dialog = false;
      this.file = "";
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 3) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()]
    },
  },
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}
</style>